import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import MUIDataTable from 'mui-datatables'
import { withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
// import { Select } from '@material-ui/core'
import Select from 'react-select'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar/withSharedSnackbar'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
// import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import getLoginId from '../../../utils/getLoginId'
import FormHelperText from '@material-ui/core/FormHelperText'
// import FileSaver from "file-saver";
// import ExcelJS from "exceljs";
// import * as XLSX from 'xlsx'
// import FileSaver from 'file-saver'
import Multiselect from 'multiselect-react-dropdown'

import { DatePicker } from 'material-ui-pickers'
// import {
//     MobileDateTimePicker,
//   } from "@mui/x-date-pickers";
import moment from 'moment'
// import { sync } from 'resolve'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  },
  button: {
    margin: theme.spacing.unit * 1
  }
})

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int, $status: Int) {
    clientsDetails: allClientDetails(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      clientName
      loginId
      partner {
        businessName
      }
    }
  }
`
const ALL_VEH = gql`
  query allClientDetails($partnerLoginId: Int) {
    allVehicles: getAllVehicleDetailsByStatus(
      partnerLoginId: $partnerLoginId
      status: 1
    ) {
      vehicleNumber
      clientLoginId
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`

const REFUEL_AND_PILFERAGE_ALERTS_QUERY = gql`
  query getRefuelAndPilferageAlerts(
    $clientLoginIds: [Int!]
    $startTime: Int
    $endTime: Int
    $forAllVehicles: Boolean
    $vehicleNumbers: [String!]
  ) {
    getRefuelAndPilferageAlerts(
      clientLoginIds: $clientLoginIds
      startTime: $startTime
      endTime: $endTime
      forAllVehicles: $forAllVehicles
      vehicleNumbers: $vehicleNumbers
    ) {
      vehicleNumber
      date
      eventType
      eventVolume
      startTime
      endTime
      loc
      lat
      lng
    }
  }
`

export class PilRefuleAlerts extends Component {
  state = {
    detailedAlertsLoading: false,
    isLoading: false,
    selectedFormDate: new Date(),
    allVehicles: [],
    allVehiclesOption: [],
    rawData: [],
    clientsDetails: [],
    vehicleDetails: [],
    selectedClients: [],
    clientLoginIds: [],
    selectedVehicles: [],
    selectedUniqueIds: [],
    response: [],
    getAllVeh: 'false',
    startTime: moment()
      .unix()
      .toString(),
    startDate: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    endDate: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    endTime: moment()
      .unix()
      .toString(),
    partnerLoginId: getLoginId()
  }
  columns = [
    {
      name: 'vehicleNumber',
      label: 'Vehicle Number'
    },
    {
      name: 'date',
      label: 'Date'
    },
    {
      name: 'startTime',
      label: 'Start Time'
    },
    {
      name: 'endTime',
      label: 'End Time'
    },
    {
      name: 'eventType',
      label: 'event Type'
      // dataType: 'number'
    },
    {
      name: 'eventVolume',
      label: 'Event Volume'
    },
    {
      name: 'loc',
      label: 'Event Address'
    },
    {
      name: 'lat',
      label: 'lat'
    },
    {
      name: 'lng',
      label: 'lng'
    }
  ]

  handleCellClick(cellValue) {
    console.log(cellValue)
    this.setState({ rawData: cellValue })
  }
  handleFromDate = date => {
    this.setState({ selectedFormDate: date })
    var finalStart = moment(date).unix()
    this.setState({ fromDate: finalStart })

    var dateNow = new Date(date) // Now
    dateNow.setDate(dateNow.getDate() + 30)
    this.setState({ toMaxDate: dateNow })
  }
  options = {
    filter: true
  }
  handleSubmit = async () => {
    this.setState({ isLoading: true })
    const res = await this.props.client.query({
      query: REFUEL_AND_PILFERAGE_ALERTS_QUERY,
      variables: {
        clientLoginIds: this.state.selectedClients,
        vehicleNumbers: this.state.selectedVehicles,
        startTime: parseInt(this.state.startTime),
        endTime: parseInt(this.state.endTime),
        forAllVehicles:
          this.state.getAllVeh === 'true' ? Boolean(true) : Boolean(false)
      },
      fetchPolicy: 'network-only'
    })
    let resData = res.data.getRefuelAndPilferageAlerts
    this.setState({ response: resData, isLoading: false })
    console.log(resData)

    console.log(res)
  }
  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        status: parseInt(1, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log(clientsDetails)
    const allClients = clientsDetails.data.clientsDetails.map(client => ({
      name: client.loginId,
      label: client.clientName
    }))
    console.log(allClients)
    this.setState({ clientsDetails: allClients })
  }

  getAllVehicles = async () => {
    const allVehicles = await this.props.client.query({
      query: ALL_VEH,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10)
      },
      fetchPolicy: 'network-only'
    })
    console.log(allVehicles.data.allVehicles)
    const allvehs = allVehicles.data.allVehicles.map(veh => ({
      value: veh.vehicleNumber,
      label: veh.vehicleNumber
    }))
    this.setState({
      allVehicles: allVehicles.data.allVehicles,
      allVehiclesOption: allvehs
    })
  }
  async componentDidMount() {
    this.getAllClients()
    this.getAllVehicles()
  }
  getVehicleDetails = async ids => {
    let clientLoginIds = ids
    console.log(clientLoginIds)
    if (clientLoginIds && clientLoginIds.length > 0) {
      let vehicleFiltered = this.state.allVehicles.filter(item =>
        clientLoginIds.includes(item.clientLoginId)
      )
      const filteredVeh = vehicleFiltered.map(veh => ({
        value: veh.vehicleNumber,
        label: veh.vehicleNumber
      }))
      console.log(filteredVeh)
      this.setState({ vehicleDetails: filteredVeh })
    }
  }

  handleGetAll = event => {
    console.log(event.target.value)
    let a = event.target.value
    console.log(a)
    this.setState({ getAllVeh: a })
  }

  handleStartDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    console.log(date)
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate, startTime: tempDate.unix })
  }

  handleEndDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    console.log(date)
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate, endTime: tempDate.unix })
  }

  handleClientRemove = (selectedList, removedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.name)
    this.setState({
      selectedClients: updatedSelectedClients,
      selectedVehicles: []
    })
    this.getVehicleDetails(updatedSelectedClients)
  }

  handleClientSelect = (selectedList, selectedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.name)
    this.setState({
      selectedClients: updatedSelectedClients,
      selectedVehicles: []
    })
    this.getVehicleDetails(updatedSelectedClients)
  }

  handleVehicleRemove = (selectedList, removedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.value)
    this.setState({ selectedVehicles: updatedSelectedClients })
  }

  handleVehicleSelect = (selectedList, selectedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.value)
    this.setState({ selectedVehicles: updatedSelectedClients })
  }

  downloadExcel = (buildHead, buildBody, columns, data) => {
    console.log('in download excel function.....')

    const processedData = data.map(row => {
      const processedRow = { ...row }
      if (row.data && Array.isArray(row.data)) {
        const processedDataArray = row.data.map(
          item =>
            Array.isArray(item)
              ? // ? item.map(subItem => Object.values(subItem).join(' ')).join(',')
                JSON.stringify(item)
              : item === null
                ? 'NoNextEvent'
                : item
        )
        processedRow.data = processedDataArray
      }
      return processedRow
    })

    const csvContent = `${buildHead(columns)}\n${buildBody(processedData)}`
    const blob = new Blob([csvContent], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'exported_data.csv'
    link.click()
    window.URL.revokeObjectURL(link.href)
    link.remove()
    return false
  }

  render() {
    console.log(this.state)
    console.log(this.props)
    const { classes } = this.props
    const {
      detailedAlertsLoading,
      clientsDetails,
      selectedClients
    } = this.state
    return (
      <div className={classes.root}>
        <Typography variant="title" gutterBottom>
          <p>
            Refuel And Pilferage Alerts<br />
            <br />
          </p>
        </Typography>
        <Grid
          container
          spacing={16}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid container style={{ display: 'flex', alignItems: 'center' }}>
            <Grid
              container
              className="searchdiv"
              spacing={8}
              justify="center"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={12} sm={12}>
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Clinet LoginIDs :
                </label>

                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Multiselect
                      displayValue="label"
                      onKeyPressFn={function noRefCheck() {}}
                      onSearch={function noRefCheck() {}}
                      onRemove={this.handleClientRemove}
                      onSelect={this.handleClientSelect}
                      options={this.state.clientsDetails}
                      placeholder="Select ClinetLoginIDs"
                    />

                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Vehicle Numbers :
                </label>

                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Multiselect
                      displayValue="label"
                      onKeyPressFn={function noRefCheck() {}}
                      onSearch={function noRefCheck() {}}
                      onRemove={this.handleVehicleRemove}
                      onSelect={this.handleVehicleSelect}
                      placeholder="Select Vehicles"
                      options={
                        this.state.selectedClients.length == 0
                          ? this.state.allVehiclesOption
                          : this.state.vehicleDetails
                      }
                    />

                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              fullwidth="true"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <label
                style={{
                  marginRight: '10px'
                }}
              >
                Get AllVehicles:
              </label>
              <FormControl
                style={{
                  minWidth: '50%'
                }}
              >
                <FormGroup row className="form-input">
                  <RadioGroup
                    aria-label="getAllVeh"
                    name="getAllVeh"
                    value={this.state.getAllVeh}
                    onChange={this.handleGetAll}
                    row
                  >
                    <FormControlLabel
                      value={'true'}
                      control={<Radio />}
                      label="true"
                    />
                    <FormControlLabel
                      value={'false'}
                      control={<Radio />}
                      label="false"
                    />
                  </RadioGroup>
                  <FormHelperText id="name-error-text" className="Error_msg" />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <DatePicker
                      format="DD/MM/YYYY"
                      maxDate={new Date()}
                      value={this.state.startDate.date}
                      onChange={this.handleStartDateChange('startDate')}
                      label="Start Date"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <DatePicker
                      format="DD/MM/YYYY"
                      maxDate={new Date()}
                      value={this.state.endDate.date}
                      onChange={this.handleEndDateChange('endDate')}
                      label="End Date"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <FormGroup
          className="form-input"
          style={{
            padding: '25px'
          }}
        >
          <Grid justify="left" container>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={this.handleSubmit}
            >
              ↪ Submit
            </Button>
          </Grid>
        </FormGroup>

        <Grid item xs={12}>
          {detailedAlertsLoading ? (
            <div>Loading...</div>
          ) : this.state.isLoading ? (
            <div>Loading...</div>
          ) : (
            <MUIDataTable
              title="Refuel And Pilferage Alerts"
              data={this.state.response}
              columns={this.columns}
              options={{
                onDownload: this.downloadExcel
              }}
            />
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(PilRefuleAlerts))
)



// WEBPACK FOOTER //
// ./src/components/Pages/RefuelAndPilferageAlerts/index.js